import {Colors} from './colors';


export class FilterItem {
  toggle = true;
  label: string | undefined = undefined;
  color: string = Colors.info;
}
